import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { NavController, ModalController, IonicModule } from '@ionic/angular';
import { MenuController } from '@ionic/angular';
import { ItemsManagerProvider } from '../../providers/items-manager/items-manager';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { FriendsManagerProvider } from '../../providers/friends-manager/friends-manager';
import { ChatsManagerProvider } from '../../app/modules/core/Providers/chats-manager';
import { AdsService } from '../../providers/ads-manager/ads-service';
import { UserManagerProvider } from '../../providers/user-manager/user-manager';
import { SocketManagerProvider } from '../../providers/socket-manager/socket-manager';
import { Chat } from '../../bayadic-shared-models/chat/Chat';
import * as Enums from '../../bayadic-shared-models/enums/Enums';
import { Events } from '../../providers/events/events';
import { NavigationExtras, Router } from '@angular/router';
import { CommonModule, Location } from '@angular/common';
import { MatToolbarModule } from '@angular/material/toolbar';
import { FormsModule } from '@angular/forms';
import { LoggerService } from '../../app/services/logger.service';
import { NavigationService } from '../../app/services/navigation.service';

@Component({
  standalone: true,
  selector: 'comp-header',
  templateUrl: 'comp-header.html',
  styleUrls: ['comp-header.scss'],
  imports: [IonicModule,
     CommonModule,MatToolbarModule, TranslateModule, FormsModule
    ]

})
export class CompHeaderComponent {

  @Input('myText') titelTextInput: string;
  @Input('chatPage') chatPage: any;
  @Input('friendsPage') friendsPage: any;
  @Input('allowDescription') allowDescription: any;
  @Input('itemsPage') itemsPage: any;
  @Input('showMenuBtn') showMenuBtn: boolean = false;
  @Input('showBackBtn') showBackBtn: boolean = true;
  @Output() onBack = new EventEmitter()
  

  @Input('chat') chat: Chat;
  @ViewChild('navbar', { static: false }) navBar: { backButtonClick: () => void; };
  needle: string;
  searchInputVisible: boolean;
  socketMgrConnected: boolean = false;

  constructor(public navCtrl: NavController,
    public location: Location,
    public itemsManager: ItemsManagerProvider,
    public chatsManager: ChatsManagerProvider,
    public userManager: UserManagerProvider,
    public view: ModalController,
    public translateService: TranslateService,
    public friendsManager: FriendsManagerProvider,
    public adsManager: AdsService,
    private menu: MenuController,
    public navigationService: NavigationService,
    public events: Events,
    public socketManager: SocketManagerProvider,
    private router: Router,
    public logger: LoggerService
  ) {

    this.searchInputVisible = false;
    this.registerEvents();
  }
  registerEvents() {
    this.events.subscribe('resumeApp', () => {
      this.search();
      this.closeInput();
    });
    this.registerConnectedSocket();
    this.registerResume();
  }
  ngOnInit(): void {
    // Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    // Add 'implements OnInit' to the class.

  }
  registerConnectedSocket() {

    this.events.subscribe(Enums.EVENTS_Locally.Connected, () => {
      this.socketMgrConnected = true;
      this.ngOnInit();
    });
    this.events.subscribe(Enums.EVENTS_Locally.SocketDisconnected, () => {
      this.socketMgrConnected = false;
    });
  }
  registerResume() {
  }

  ionViewDidEnter() {
    this.navBar.backButtonClick = () => {
      this.logger.debug('hallo back button');
      this.backButtonClick();
      /// here you can do wathever you want to replace the backbutton event
    };

  }
  async connectAgain() {
    this.logger.debug('connect again');
    // await this.socketManager.connect();
  }
  disconnect() {
    this.logger.debug('serve disconnect');
    this.socketManager.disconnect();
  }

  openFirst() {
    this.menu.enable(true, 'first');
    this.menu.open('first');
  }

  openEnd() {
    this.menu.open('end');
  }

  openCustom() {
    this.menu.enable(true, 'custom');
    this.menu.open('custom');
  }

  search() {
    this.openInput();
  }
  cancel() {
    this.closeInput();
  }
  hasSearchBtn() {
    return false;
  }
  closeInput() {
    if (this.chatPage) {
      this.chat.searching = false;
      this.chat.endSearch();
    }
    if (this.itemsPage) {
      this.itemsManager.endSearch();
    }
    if (this.friendsPage) {
      this.friendsManager.endSearch();
    }

    this.searchInputVisible = false;
    this.needle = '';
  }
  openInput() {
    if (this.chatPage) {
      this.chat.searching = true;
    }
    if (this.itemsPage) {

      this.itemsManager.searchBackUp();
    }
    if (this.friendsPage) {
      this.friendsManager.searchBackUp();
    }
    this.searchInputVisible = true;
  }
  backButtonClick() {
    this.logger.debug('lets see some ads def');
  }
  isQuiz() {
    if (this.chat) {
      return this.chat.isQuiz();
    }
  }
  goBack() {
    // Check if there is navigation history
    if (this.location.isCurrentPathEqualTo('/profile/signup') || 
        this.location.isCurrentPathEqualTo('/profile/forgotpassword')) {
        this.navCtrl.navigateBack('/profile/login');
    } else if (window.history.length > 1) {
      // this.location.back();
      this.logger.debug('back button clicked');
      // this.navCtrl.back();
      this.navigationService.goBack();
    } else {
      this.router.navigate(['/items']); // Navigate to the items page if no history
    }
   

    // Emit the back event
    this.onBack.emit(true);
}

  onInput(e: any) {
    if (this.chatPage) {
      return false;
      //          this.chatsManager.currentChat.search(this.needle);
      //          this.chatsManager.searchInChat(this.needle);
    }
    if (this.itemsPage) {

      this.itemsManager.search(this.needle);
    }
    if (this.friendsPage) {
      this.friendsManager.search(this.needle);
    }
  }
  searchInDatabase() {
    if (this.chatPage) {
      //          this.chatsManager.currentChat.search(this.needle);
      if (this.needle.length > 0) {
        this.chatsManager.searchInChat(this.needle);
      }
    }
  }
  showDetails() {
    if (this.chat.item.userID == this.userManager.user.userID && this.chat.isDictionary()) {
      this.logger.debug('this.chat', this.chat);
      const navigationExtras: NavigationExtras = {
        state: {
          chat: this.chat
        }
      };

      this.router.navigate(['chat/membersPage'], navigationExtras);
    }
  }
  //   showDetails(){
  //       if (!this.chat || !this.allowDescription){
  //           this.logger.debug("this is not a chat page");
  //         return;
  //       }
  //       if (this.chat.isChat()){
  //           return false;
  //       }

  //       else {
  //           this.logger.debug("is this chat", this.chat);
  //       }
  //     //   this.router.navigate(MembersPage, {'chat': this.chat});
  //   }
  isChatPage() {
    return this.chatPage;
  }
  showChatOptionMenu() {
    this.chat.setShowOptionMenu(true);
    // this.chat.setShowOptionMenu(false);
    // this.search();
  }
  isConnected() {
    return this.socketManager.connected;
    // return this.socketMgrConnected;
  }
  isShowOptionMenu() {
    if (this.chat) {
      return this.chat.isShowOptionMenu();
    }
  }
  showMenu() {
    this.menu.open();
  }


}
